export const createContactsData = ({
  section = undefined,
  // individuals = [createIndividuals({})],
  // companies = [createCompanies({})],
  contacts = [],
  startRow = 0,
  user = createUser({}),
  client = createClient({}),
  action = undefined
} = {}) => {
  return {
    section,
    user,
    // individuals,
    // companies,
    contacts: contacts.map(createContacts), 
    startRow,
    client,
    action
  }
};

const createContacts = ({
  notes = undefined,
  url3 = undefined,
  formality = undefined,
  valid_vat_no_flag = undefined,
  phone2 = undefined,
  url2 = undefined,
  address2 = undefined,
  vat_type_id = undefined,
  invoice_discount_percent = undefined,
  iCal_password = undefined,
  postbox = undefined,
  bank_name = undefined,
  region = undefined,
  bank_address = undefined,
  mobile2 = undefined,
  mobile1 = undefined,
  birthdate = undefined,
  postalcode = undefined,
  address1 = 0,
  chat3 = undefined,
  url4 = undefined,
  cost_center = undefined,
  vat_no = undefined,
  last_modified = '',
  first_name = '',
  skype = undefined,
  debitor_no = undefined,
  request = undefined,
  tax_no = undefined,
  gender = undefined,
  url1 = undefined,
  default_declaration_text2 = undefined,
  cost_discount_percent = undefined,
  main_promoter = undefined,
  aim = undefined,
  cost_payment_method_id = undefined,
  cost_due_days = undefined,
  fax1 = undefined,
  title = undefined,
  iban = undefined,
  account_holder = undefined,
  created = '',
  date_end = undefined,
  invoice_end_of_month_flag = undefined,
  language = undefined,
  passport_no = undefined,
  creditor_no = undefined,
  city = undefined,
  country = undefined,
  nick_name = undefined,
  cost_end_of_month_flag = undefined,
  email1 = '',
  default_declaration_text1 = undefined,
  date_start = undefined,
  fax2 = undefined,
  customer_no = '',
  vat_no_confirmed = undefined,
  last_name = '',
  invoice_due_days = undefined,
  sortcode = undefined,
  invoice_payment_method_id = undefined,
  email2 = undefined,
  company_legalname = '',
  cost_discount_days = undefined,
  swift = undefined,
  invoice_discount_days = undefined,
  contact_id = 0,
  currency_id = 0,
  phone1 = 0,
  company_name = '',
  account_no = undefined
} = {}) => {
  return {
    notes,
    url3,
    formality,
    valid_vat_no_flag,
    phone2,
    url2,
    address2,
    vat_type_id,
    invoice_discount_percent,
    iCal_password,
    postbox,
    bank_name,
    region,
    bank_address,
    mobile2,
    mobile1,
    birthdate,
    postalcode,
    address1,
    chat3,
    url4,
    cost_center,
    vat_no,
    last_modified,
    first_name,
    skype,
    debitor_no,
    request,
    tax_no,
    gender,
    url1,
    default_declaration_text2,
    cost_discount_percent,
    main_promoter,
    aim,
    cost_payment_method_id,
    cost_due_days,
    fax1,
    title,
    iban,
    account_holder,
    created,
    date_end,
    invoice_end_of_month_flag,
    language,
    passport_no,
    creditor_no,
    city,
    country,
    nick_name,
    cost_end_of_month_flag,
    email1,
    default_declaration_text1,
    date_start,
    fax2,
    customer_no,
    vat_no_confirmed,
    last_name,
    invoice_due_days,
    sortcode,
    invoice_payment_method_id,
    email2,
    company_legalname,
    cost_discount_days,
    swift,
    invoice_discount_days,
    contact_id,
    currency_id,
    phone1,
    company_name,
    account_no,

    // getName: () => first_name ? `${first_name} ${last_name}` : `${company_name}`
  }
};



const createIndividuals = ({
  currency_id = undefined,
  phone1 = '',
  invoice_end_of_month_flag = undefined,
  address2 = undefined,
  chat3 = undefined,
  creditor_no = undefined,
  postalcode = '',
  vat_no_confirmed = undefined,
  iCal_password = undefined,
  company_name = undefined,
  nick_name = undefined,
  url2 = undefined,
  fax2 = undefined,
  date_end = undefined,
  cost_due_days = undefined,
  cost_discount_percent = undefined,
  notes = undefined,
  invoice_discount_percent = undefined,
  cost_end_of_month_flag = undefined,
  default_declaration_text2 = undefined,
  url3 = undefined,
  date_start = undefined,
  mobile1 = undefined,
  cost_payment_method_id = undefined,
  customer_no = undefined,
  title = undefined,
  first_name = '',
  valid_vat_no_flag = undefined,
  last_modified = '',
  sortcode = undefined,
  aim = undefined,
  debitor_no = undefined,
  created = '',
  contact_id = 0,
  cost_discount_days = undefined,
  email1 = '',
  city = '',
  swift = undefined,
  address1 = '',
  company_legalname = undefined,
  email2 = undefined,
  url4 = undefined,
  main_promoter = undefined,
  gender = undefined,
  birthdate = undefined,
  skype = undefined,
  last_name = '',
  mobile2 = undefined,
  country = '',
  invoice_due_days = undefined,
  passport_no = undefined,
  tax_no = undefined,
  bank_name = undefined,
  language = '',
  request = undefined,
  vat_type_id = undefined,
  vat_no = undefined,
  invoice_discount_days = undefined,
  account_no = undefined,
  iban = undefined,
  cost_center = undefined,
  bank_address = undefined,
  phone2 = undefined,
  region = undefined,
  account_holder = undefined,
  url1 = '',
  fax1 = '',
  invoice_payment_method_id = undefined,
  default_declaration_text1 = undefined,
  postbox = undefined,
  formality = undefined
} = {}) => {
  return {
    currency_id,
    phone1,
    invoice_end_of_month_flag,
    address2,
    chat3,
    creditor_no,
    postalcode,
    vat_no_confirmed,
    iCal_password,
    company_name,
    nick_name,
    url2,
    fax2,
    date_end,
    cost_due_days,
    cost_discount_percent,
    notes,
    invoice_discount_percent,
    cost_end_of_month_flag,
    default_declaration_text2,
    url3,
    date_start,
    mobile1,
    cost_payment_method_id,
    customer_no,
    title,
    first_name,
    valid_vat_no_flag,
    last_modified,
    sortcode,
    aim,
    debitor_no,
    created,
    contact_id,
    cost_discount_days,
    email1,
    city,
    swift,
    address1,
    company_legalname,
    email2,
    url4,
    main_promoter,
    gender,
    birthdate,
    skype,
    last_name,
    mobile2,
    country,
    invoice_due_days,
    passport_no,
    tax_no,
    bank_name,
    language,
    request,
    vat_type_id,
    vat_no,
    invoice_discount_days,
    account_no,
    iban,
    cost_center,
    bank_address,
    phone2,
    region,
    account_holder,
    url1,
    fax1,
    invoice_payment_method_id,
    default_declaration_text1,
    postbox,
    formality,

    getName: () => `${first_name} ${last_name}`
  }
};



const createUser = ({
  module_settings_flag = 0,
  password = '',
  staff_phone1 = undefined,
  user_name = '',
  contact_id = undefined,
  smtp_username = undefined,
  created = '',
  booking_report_flag = 0,
  dashboard_settings = createDashboard_settings({}),
  accounting_flag = 0,
  general_flag = 0,
  signature_link = undefined,
  staff_fullname = undefined,
  general_more_flag = 0,
  accounting_more_flag = 0,
  contacts_flag = 0,
  smtp_password = undefined,
  promotion_flag = 0,
  last_modified = '',
  distribution_flag = 0,
  client_code = undefined,
  job_title = undefined,
  booking_flag = 0,
  label_more_flag = 0,
  general_settings_flag = 0,
  management_flag = 0,
  user_id = 0,
  language = '',
  publishing_flag = 0,
  staff_email = '',
  label_flag = 0,
  staff_phone2 = undefined,
  user_settings_flag = 0,
  contact_export_import_flag = 0,
  smtp_server = undefined,
  booking_more_flag = 0,
  publishing_more_flag = 0,
  permissions = createPermissions({})
} = {}) => {
  return {
    module_settings_flag,
    password,
    staff_phone1,
    user_name,
    contact_id,
    smtp_username,
    created,
    booking_report_flag,
    dashboard_settings,
    accounting_flag,
    general_flag,
    signature_link,
    staff_fullname,
    general_more_flag,
    accounting_more_flag,
    contacts_flag,
    smtp_password,
    promotion_flag,
    last_modified,
    distribution_flag,
    client_code,
    job_title,
    booking_flag,
    label_more_flag,
    general_settings_flag,
    management_flag,
    user_id,
    language,
    publishing_flag,
    staff_email,
    label_flag,
    staff_phone2,
    user_settings_flag,
    contact_export_import_flag,
    smtp_server,
    booking_more_flag,
    publishing_more_flag,
    permissions
  }
};


const createDashboard_settings = ({

} = {}) => {
  return {

  }
};



const createPermissions = ({
  allowed = createAllowed({}),
  blocked = createBlocked({})
} = {}) => {
  return {
    allowed,
    blocked
  }
};


const createAllowed = ({
  roles = ['']
} = {}) => {
  return {
    roles
  }
};



const createBlocked = ({
  tabs = [''],
  sub_menu = ['']
} = {}) => {
  return {
    tabs,
    sub_menu
  }
};





const createCompanies = ({
  account_holder = undefined,
  account_no = undefined,
  address1 = '',
  address2 = '',
  aim = undefined,
  bank_address = undefined,
  bank_name = undefined,
  birthdate = undefined,
  chat3 = undefined,
  city = '',
  company_legalname = undefined,
  company_name = '',
  contact_id = 0,
  cost_center = undefined,
  cost_discount_days = undefined,
  cost_discount_percent = undefined,
  cost_due_days = undefined,
  cost_end_of_month_flag = undefined,
  cost_payment_method_id = undefined,
  country = '',
  created = '',
  creditor_no = undefined,
  currency_id = undefined,
  customer_no = undefined,
  date_end = undefined,
  date_start = undefined,
  debitor_no = undefined,
  default_declaration_text1 = undefined,
  default_declaration_text2 = undefined,
  email1 = '',
  email2 = undefined,
  fax1 = undefined,
  fax2 = undefined,
  first_name = undefined,
  formality = undefined,
  gender = undefined,
  iCal_password = undefined,
  iban = undefined,
  invoice_discount_days = undefined,
  invoice_discount_percent = undefined,
  invoice_due_days = undefined,
  invoice_end_of_month_flag = undefined,
  invoice_payment_method_id = undefined,
  language = '',
  last_modified = '',
  last_name = undefined,
  main_promoter = undefined,
  mobile1 = undefined,
  mobile2 = undefined,
  nick_name = undefined,
  notes = undefined,
  passport_no = undefined,
  phone1 = '',
  phone2 = undefined,
  postalcode = '',
  postbox = undefined,
  region = undefined,
  request = undefined,
  skype = undefined,
  sortcode = undefined,
  swift = undefined,
  tax_no = '',
  title = undefined,
  url1 = '',
  url2 = undefined,
  url3 = undefined,
  url4 = undefined,
  valid_vat_no_flag = 0,
  vat_no = '',
  vat_no_confirmed = undefined,
  vat_type_id = undefined,
} = {}) => {
  return {
    account_holder,
    account_no,
    address1,
    address2,
    aim,
    bank_address,
    bank_name,
    birthdate,
    chat3,
    city,
    company_legalname,
    company_name,
    contact_id,
    cost_center,
    cost_discount_days,
    cost_discount_percent,
    cost_due_days,
    cost_end_of_month_flag,
    cost_payment_method_id,
    country,
    created,
    creditor_no,
    currency_id,
    customer_no,
    date_end,
    date_start,
    debitor_no,
    default_declaration_text1,
    default_declaration_text2,
    email1,
    email2,
    fax1,
    fax2,
    first_name,
    formality,
    gender,
    iCal_password,
    iban,
    invoice_discount_days,
    invoice_discount_percent,
    invoice_due_days,
    invoice_end_of_month_flag,
    invoice_payment_method_id,
    language,
    last_modified,
    last_name,
    main_promoter,
    mobile1,
    mobile2,
    nick_name,
    notes,
    passport_no,
    phone1,
    phone2,
    postalcode,
    postbox,
    region,
    request,
    skype,
    sortcode,
    swift,
    tax_no,
    title,
    url1,
    url2,
    url3,
    url4,
    valid_vat_no_flag,
    vat_no,
    vat_no_confirmed,
    vat_type_id,

    getName: () => `${company_name}`
  }
};



const createClient = ({
  display_name = ''
} = {}) => {
  return {
    display_name
  }
};


 


